// extracted by mini-css-extract-plugin
export default {"wrapper":"A_CheckboxItem_wrapper__NRNP1"};